import React, { FC, useEffect, useRef } from "react";

interface IProps {
  signalOpen: number;
  setImage(image: string): void;
}

const SelectImageFileDialog: FC<IProps> = ({ signalOpen, setImage }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const isMounted = useRef<Boolean>(false);

  useEffect(() => {
    if (isMounted.current) {
      console.log("handle signal open");
      fileInputRef.current?.click();
    } else {
      console.log("not handling signal open - not mounted");
      isMounted.current = true;
    }
  }, [signalOpen]);

  const handleFileSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      // Check the file type here
      const allowedTypes = [
        "image/png",
        "image/gif",
        "image/jpeg",
        "image/jpg",
        "image/tif",
      ];

      if (allowedTypes.includes(file.type)) {
        console.log("File type is allowed:", file.type);
        setImage(URL.createObjectURL(file));
        // Handle the file as needed
      } else {
        console.log("Invalid file type. Please select a supported image file.");
        // Optionally, you can show an error message to the user
      }
    }
  };

  return (
    <>
      <input
        type="file"
        id="fileInput"
        accept=".png, .gif, .jpg, .jpeg, .tif"
        style={{ display: "none" }}
        onChange={handleFileSelected}
        ref={fileInputRef}
      />
    </>
  );
};

export default SelectImageFileDialog;
